import {PricingItem} from 'src/app/core/models/quote/pricing-item/pricing-item';
import {DevicePricingItem} from 'src/app/core/models/quote/pricing-item/device-pricing-item';
import {ConsumablePricingItem} from 'quote-export-manager-core';
import {KeyValue} from '@angular/common';
import {BillingLine} from 'src/app/core/models/billing-line/billing-line.model';
import {ProductPricingV2} from 'src/app/core/models/productv2/productpricingv2.model';
import {DiscoPricingItemInitializer} from '../disco.pricing-item-initializer';
import {NumberOfChangeStock} from 'src/app/core/models/number-of-change-stock/number-of-change-stock';
import {ProductV2} from '../../../../core/models/productv2/productv2.model';


export class DiscoVtRenewalPricingItemInitializer extends DiscoPricingItemInitializer {

    initUserInputs(customerContract: BillingLine, prefilledInputs: any, pricingItem: PricingItem) {
        let userInputs = super.initUserInputs(customerContract, prefilledInputs, pricingItem);
        if (pricingItem instanceof ConsumablePricingItem) {
            Object.assign(userInputs, {
                consumableQuantity: customerContract.weeklyQuantity,
            });
        } else {
            let stockVT = null;
            const foundNumberOfChange = prefilledInputs.numberOfChanges?.find(item => item.value == customerContract.numberOfChanges) ?? null;
            let selectedValueNumberOfChange = foundNumberOfChange?.value || foundNumberOfChange;
            if (pricingItem instanceof DevicePricingItem) {
                if (!pricingItem.isCmc) {
                    stockVT = this.getStockVTByNumberOfChange(selectedValueNumberOfChange, prefilledInputs.numberOfChangeStock);
                } else {
                    stockVT = this.getInitStockVTByNumberOfChange(selectedValueNumberOfChange, prefilledInputs.stockVTs);
                }
            }
            Object.assign(userInputs, {
                numberOfChange: foundNumberOfChange || prefilledInputs.numberOfChanges[0],
                quantity: customerContract.weeklyQuantity,
                stockVT,
            });
        }

        return userInputs;
    }

    getInitStockVTByNumberOfChange(selectedNumberOfChange: string, stockVTs: {
        numberOfChange: string;
        stockVT: { key: string; value: string }[]
    }[]) {
        const result = stockVTs.find((item) => item.numberOfChange === selectedNumberOfChange);
        if (result && result.stockVT && result.stockVT.length > 0) {
            return result.stockVT[0];
        }
        return null;
    }

    getPrefilledInputs(productPricings: ProductPricingV2[], referential: any, customerContract: BillingLine): Record<string, any> {
        let prefilledInputs = super.getPrefilledInputs(productPricings, referential, customerContract);
        const numberOfChanges: KeyValue<string, string>[] = [];
        productPricings?.forEach(pp => {
            if (pp.numberOfChange != '' && numberOfChanges.filter(e => e.key === pp.numberOfChange).length === 0) {
                numberOfChanges.push({
                    key: pp.numberOfChange,
                    value: pp.numberOfChange
                });
            }
        });
        if (!!customerContract.numberOfChanges && !numberOfChanges.some(e => e.key?.toLowerCase() === customerContract.numberOfChanges?.toLowerCase())) {
            numberOfChanges.push({
                key: customerContract.numberOfChanges?.toLowerCase(),
                value: customerContract.numberOfChanges?.toLowerCase(),
            });
        }

        const stockVTs = this.prefilledStockVts(productPricings);

        Object.assign(prefilledInputs, {
            numberOfChanges: numberOfChanges,
            stockVTs: stockVTs,
            numberOfChangeStock: referential.numberOfChangeStock
        });

        return prefilledInputs;
    }

    prefilledStockVts(productPricing: ProductPricingV2[]): { numberOfChange: string; stockVT: { key: string; value: string }[] }[] {
        const resultMap = new Map<string, string[]>();
        productPricing.forEach((entry) => {
            const {stockVT, numberOfChange} = entry.productPricingDetails;
            if (null != stockVT) {
                if (resultMap.has(numberOfChange)) {
                    const values = resultMap.get(numberOfChange)!;
                    values.push(stockVT);
                    values.sort((a, b) => a.localeCompare(b));
                } else {
                    resultMap.set(numberOfChange, [stockVT]);
                }
            }
        });

        // Convert the map to a list ( store need)
        const resultList: { numberOfChange: string; stockVT: { key: string; value: string }[] }[] = [];
        resultMap.forEach((stockVT, numberOfChange) => {
            const transformedStockVT = stockVT.map((item) => ({key: item, value: item})); // Convert to key-value pairs for optionList need
            resultList.push({numberOfChange, stockVT: transformedStockVT});
        });

        return resultList;
    }

    getStockVTByNumberOfChange(selectedNumberOfChange: string, numberOfChanges: NumberOfChangeStock[]) {
        return numberOfChanges.find(item => item.numberOfChange === selectedNumberOfChange)?.stock || null;
    }


    protected findMatchingProductPricing(productPricings: ProductPricingV2[], pricingItem: PricingItem) {
        return productPricings?.find(pp => pp.frequency === pricingItem.userInputs['frequency'].key
            && Number(pp.minQuantity) <= pricingItem.userInputs['quantity']
            && Number(pp.maxQuantity) >= pricingItem.userInputs['quantity']
            && pp.numberOfChange === pricingItem.userInputs['numberOfChange'].key
        );
    }


    completeProductPricingsWithProduct(cmcProduct: ProductV2, product: ProductV2) {

        let standardProductPricings = this.getStandardProduct(cmcProduct.priceList.productPricings, product.priceList?.productPricings);
        if (standardProductPricings) {
            standardProductPricings.forEach(pp => {
                pp['type'] = 'STANDARD';
            });
            cmcProduct.priceList.productPricings = cmcProduct.priceList.productPricings.concat(standardProductPricings);
            cmcProduct['isCmcWithStandardProductPricing'] = true;
        }
    }

    getStandardProduct(cmcProductPricings: ProductPricingV2[], standardProductPricings: ProductPricingV2[]): ProductPricingV2[] {
        return standardProductPricings.filter(standardProductPricing =>
            !cmcProductPricings.some(cmcProductPricing =>
                cmcProductPricing.frequency === standardProductPricing.frequency
                && cmcProductPricing.numberOfChange === standardProductPricing.numberOfChange
            )
        );
    }

}
